export enum DataMappingProps {
  RAW_MATERIAL = 'raw-material',
  TRANSPORTATION = 'transportation',
  PROCESSING_FACILITY = 'processing-facility',
  PRODUCT_DISTRIBUTION = 'product-distribution',
  PRODUCT_OVERVIEW = 'product-overview',
  RAW_MATERIAL_HEADING = 'Raw Materials',
  // KG = 'Kg',
  CO = 'kgCO',
  SUB_2 = '2',
  TRANSPORTATION_HEADING = 'Raw Materials Transportation',
  PROCESSING_FACILITY_HEADING = 'Processing Facility',
  PRODUCT_DISTRIBUTION_HEADING = 'Product Distribution and Storage',
  FOURTH_ITEM = '4.',
  THIRD_ITEM = '3.',
  SECOND_ITEM = '2.',
  STAGE_1 = 'stage1',
  STAGE_2 = 'stage2',
  STAGE_3 = 'stage3',
  STAGE_4 = 'stage4',
  _2D = '2d',
  FUEL_AND_ENERGY_HEADING = "Fuel and energy",
  FUEL_AND_ENERGY = 'fuel-and-energy',
  COMMODITY_DISTRIBUTION_HEADING = 'Commodity Distribution',
  COMMODITY_DISTRIBUTION = 'commodity-distribution',
  FIELD_HEADING = 'Field',
  FIELD = 'field',
  MANURE_MANAGEMENT_ROUTE = 'manure-management',
  FARMBOX_OVERVIEW = 'overview',
  FEED = 'Animal Details',
  FEED_TRANSPORTATION = 'Feed',
  MANURE_MANAGEMENT = 'Manure Management',
  FEED_PATH = 'growth-stage',
  FEED_SUB_HEADING = 'This section captures the necessary inputs for Enteric emissions and Feed transportation. Both the results will be displayed on the results page.',
}
